/* eslint-disable linebreak-style */
import Cookies from 'js-cookie';

const TokenKey = 'Admin-Token';

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function getCookieByKey(key) {
  return Cookies.get(key);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function removeCookieByKey(key) {
  return Cookies.remove(key);
}

//
const localStorage = window.localStorage;

export function getStorageByKey(key) {
  return localStorage.getItem(key);
}

export function setStorageByKey(key, data) {
  return localStorage.setItem(key, data);
}

export function removeStorageByKey(key) {
  localStorage.removeItem(key);
}

//
const langKey = 'lang';
/**
 *
 *仅供后端，因为后端需要使用zh_CN,而前端使用标准的zh-CN.
 * @export {string} lang 语言代码
 */
export function getLang() {
  let langForCGI = Cookies.get(langKey) || 'zh_CN';
  if (langForCGI === 'zh-CN' || langForCGI === 'zh-TW') {
    langForCGI = langForCGI.replace('-', '_');
  }
  return langForCGI;
}

// 获取当前语言数据
export function getLauge(obj) {
  if (obj) {
    // 系统当前语言
    const lang = getLang();
    return obj[lang] || '';
  }
  return obj;
}
/**
 * @Author: mhyu
 * @Date: 2020-05-18 15:57:32
 * @msg:
 * @return:
 */
export function isJSON(str) {
  let result = false;
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str);
      if (obj && typeof obj === 'object') {
        result = true;
      }
    } catch (e) {
      result = false;
    }
  }
  return result;
}
/**
 * 处理多语言 数据
 * @param {Object} value 多语言数据
 * @returns String
 */
export function handleLangJSON(value) {
  let txt = '';
  if (value) {
    if (typeof value === 'object') {
      txt = getLauge(value);
    } else if (typeof value === 'string' && isJSON(value)) {
      value = JSON.parse(value);
      txt = getLauge(value);
    } else {
      txt = value;
    }
  }
  return txt;
}
/* eslint-disable no-unused-vars,eqeqeq,no-shadow,no-multi-assign,one-var,radix,camelcase,no-restricted-syntax,no-use-before-define,max-len,no-mixed-operators */
/** Author:wangl
 Data:2018-11-01 15:01
 ProjectName: pai-jaguar-mobile
 ProdoctName:WebStorm
 Name:formdata
 */
// 时间转换
/**
 * Created by jiachenpan on 16/11/18.
 */
export function parseTime(time, cFormat) {
  if (arguments.length !== 0) {
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    let date;
    if (typeof time === 'object') {
      date = time;
    } else {
      if ((`${time}`).length === 10) time = parseInt(time) * 1000;
      date = new Date(time);
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay(),
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key];
      if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
      if (result.length > 0 && value < 10) {
        value = `0${value}`;
      }
      return value || 0;
    });
    return time_str;
  }
  return null;
}
// 时间转换
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length));
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  };
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = `${o[k]}`;
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return (`00${str}`).substr(str.length);
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();
  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) { // less 1 hour
    return `${Math.ceil(diff / 60)}分钟前`;
  } else if (diff < 3600 * 24) {
    return `${Math.ceil(diff / 3600)}小时前`;
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  }
  return `${d.getMonth() + 1}月${d.getDate()}日${d.getHours()}时${d.getMinutes()}分`;
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

// 去除重复数据
export function unique(list, key) {
  const arr = [];
  for (let i = 0; i < list.length; i++) {
    if (i == 0) {
      arr.push(list[i]);
    }
    let b = false;
    if (arr.length > 0 && i > 0) {
      for (let j = 0; j < arr.length; j++) {
        if (arr[j][key] == list[i][key]) {
          b = true;
        }
      }
      if (!b) {
        arr.push(list[i]);
      }
    }
  }

  return arr;
}

/**
 * @FunctionName: 获取路径参数
 * @param {*} urlStr
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2020-11-23 11:40:16
 * @Modification history:
 * @Description:
 */
export function getRequestParam(urlStr) {
  const theRequest = {};
  const url = decodeURI(urlStr);
  if (url.indexOf('?') !== -1) {
    const str = url.substr(url.indexOf('?') + 1, url.length - 1);
    const strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  } else {
    return {};
  }
  return theRequest;
}
/**
 * @FunctionName: 获取路径key
 * @param {*} key
 * @return {*}
 * @Author: mhyu
 * @Date: 2022-02-21 15:11:51
 * @Description:
 */
export function getUrlData(key) {
  const url = decodeURI(location.href);
  const paraString = url.substring(url.indexOf('?') + 1, url.length).split('&');
  const paraObj = {};
  for (let i = 0, j; (j = paraString[i]); i++) {
    paraObj[j.substring(0, j.indexOf('=')).toLowerCase()] = j.substring(j.indexOf('=') + 1, j.length);
  }
  const returnValue = paraObj[key.toLowerCase()];
  if (typeof (returnValue) === 'undefined') {
    return '';
  }
  return returnValue;
}

export function getColorByAction(action) {
  let color = '#4469EC';
  switch (action) {
    // 同意
    case 'Accept':
      color = '#1DCC8F';
      break;
    // 拒绝
    case 'Reject':
      color = '#E03144';
      break;
    // 召回
    case 'PA_Recall':
    // 终止
    case 'PA_Terminate':
    // 返回发起人
    case 'PA_ReturnOriginator':
    // 返回上一级
    case 'PA_ReturnPrevious':
      color = '#FA9C0F';
      break;
    // 抄送
    case 'PA_CCUser':
    // 加签
    case 'PA_FreeSign':
    // 转签
    case 'PA_Redirect':
    // 沟通
    case 'PA_Communication':
      color = '#0EADB8';
      break;
    // 重新提交
    case 'reSubmit':
      color = '#098DFE';
      break;
    // 作废
    case 'PA_JabilCancel':
      color = 'rgba(24, 32, 51, 0.65)';
      break;
  }
  return color;
}
/**
 * @FunctionName: 深拷贝数组
 * @param {*} arr
 * @return {*}
 * @Author: ff
 * @Date: 2024-1-25 14:09:06
 * @Description:
 */
export function deepCopyArr(arr) {
  const copy = [];
  for (let i = 0; i < arr.length; i++) {
    if (Array.isArray(arr[i])) {
      // 递归调用深拷贝
      copy[i] = deepCopyArr(arr[i]);
    } else if (typeof arr[i] === 'object' && arr[i] !== null) {
      // 使用对象扩展运算符进行浅拷贝
      copy[i] = { ...arr[i] };
    } else {
      // 基本类型直接赋值
      copy[i] = arr[i];
    }
  }
  return copy;
}
/**
 * @FunctionName: 截取lastName首字符
 * @param {*} str
 * @return {*}
 * @Author:
 * @Date:
 * @Modification history:
 * @Description:
 */
export function lastNameFirstFun(str) {
  if (str) {
    str = str.substr(0, 1);
    // 正则表达式匹配字母
    const regex = /^[a-z]+$/;
    if (regex.test(str)) {
      str = str.toUpperCase();
    }
  }
  return str;
}

export function exportSearchList(dowLoadFileName, result, suffix = '.xls') {
  const blob = new Blob([result])
  const fileName = dowLoadFileName + suffix
  // 判断浏览器
  let brower = ''
  if (navigator.userAgent.indexOf('Edge') > -1) {
    brower = 'Edge'
  }

  if ('download' in document.createElement('a')) {
    // 非IE下载
    if (brower === 'Edge') {
      navigator.msSaveBlob(blob, fileName)
      return
    }
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href)
    // 释放URL 对象
    document.body.removeChild(elink)
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName)
  }
}
